import { makeModule } from '@codium/codium-vue'

export const storeModule = makeModule('screenTags', {
  parent: 'lists'
})
